import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

function formatTick(value, interval) {
  const date = new Date(value);
  if (interval === 'hour') {
    return date.toLocaleTimeString('nb-NO', { hour: '2-digit', minute: '2-digit' });
  }
  if (interval === 'month') {
    return date.toLocaleDateString('nb-NO', { month: 'short' });
  }
  return date.toLocaleDateString('nb-NO', { day: 'numeric', month: 'short' });
}

function CustomTooltip({ active, payload, label, interval }) {
  if (!active || !payload?.length) return null;

  const date = new Date(label);
  let dateStr;
  if (interval === 'hour') {
    dateStr = date.toLocaleString('nb-NO', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  } else if (interval === 'month') {
    dateStr = date.toLocaleDateString('nb-NO', { month: 'long', year: 'numeric' });
  } else {
    dateStr = date.toLocaleDateString('nb-NO', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  return (
    <div className="bg-gray-900 text-white px-3 py-2 rounded-lg text-sm shadow-lg">
      <p className="text-gray-300 text-xs mb-1">{dateStr}</p>
      <p className="font-semibold">{payload[0].value} besøkende</p>
    </div>
  );
}

export default function VisitorChart({ data, interval, loading }) {
  if (loading) {
    return (
      <div className="bg-white rounded-xl border border-gray-100 p-6 shadow-sm">
        <div className="h-[280px] flex items-center justify-center text-gray-400">
          Laster graf...
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-gray-100 p-6 shadow-sm">
        <div className="h-[280px] flex items-center justify-center text-gray-400">
          Ingen data ennå
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-6 shadow-sm">
      <ResponsiveContainer width="100%" height={280}>
        <AreaChart data={data} margin={{ top: 5, right: 5, bottom: 5, left: 0 }}>
          <defs>
            <linearGradient id="colorVisitors" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#059669" stopOpacity={0.15} />
              <stop offset="95%" stopColor="#059669" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
          <XAxis
            dataKey="period"
            tickFormatter={(v) => formatTick(v, interval)}
            tick={{ fontSize: 11, fill: '#9ca3af' }}
            axisLine={false}
            tickLine={false}
            minTickGap={40}
          />
          <YAxis
            tick={{ fontSize: 11, fill: '#9ca3af' }}
            axisLine={false}
            tickLine={false}
            width={35}
            allowDecimals={false}
          />
          <Tooltip content={<CustomTooltip interval={interval} />} />
          <Area
            type="monotone"
            dataKey="visitors"
            stroke="#059669"
            strokeWidth={2}
            fill="url(#colorVisitors)"
            dot={false}
            activeDot={{ r: 4, stroke: '#059669', strokeWidth: 2, fill: '#fff' }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
